import React from "react";
import { ElementBlockEditor } from "./ElementBlockEditor";

export class CardsBlockEditor extends ElementBlockEditor {
}
